import {
  INC_TIMER_DATA,
  IS_SET,
  RESET_TIMER_DATA,
  SET_TASKS_DATA,
  SET_TIMER_DATA,
} from "./actions";

const initialState = {
  timer: 0,
  tasks: 0,
  set:false
};

const TimerReducer = (state = initialState, action) => {
  switch (action.type) {
    case INC_TIMER_DATA:
      let timer=state.timer;
      // console.log('in timer reducer',timer)
      timer=timer+1
      return{
        ...state, 
        timer:timer
      }
      case IS_SET:
        // let set=state.set;
        // console.log('in timer reducer',timer)
       
        return{
          ...state, 
          set:true
        }

      case RESET_TIMER_DATA:
      let timer2=state.timer;
      // console.log('in timer reducer',timer2)
      timer2=0
      return{
        ...state, 
        timer:timer2
      }
      case SET_TASKS_DATA:
      let tasks=state.tasks;
      tasks=tasks+action.data
      // console.log('in task reducer', action.data)

      return{
        ...state, 
        tasks:tasks
      }
    default:
      return state;
  }
};
export default TimerReducer;
